export default function (locale) {
    window.location.assign(`/${locale}/checkout`);
}
